// import { useEffect, useRef } from 'react';

const NeoComponent = () => {
  // const iframeRef = useRef<HTMLIFrameElement | null>(null);

  return (
    <div className="_the-content pb-10 neoassist_container" style={{ height: '100vh', margin: 0, padding: 0 }}>
      <div className="container" style={{ height: '100%', padding: 0 }}>
        <div className="row justify-content-center" style={{ height: '100%', marginTop: -60, marginBottom: 20, marginLeft: 5, marginRight: 5 }}>          
          <div id='NeoassistCentral' style={{
            width: '100%',
            height: '100%'
          }}></div>
        </div>
      </div>
    </div>
  );
};

export default NeoComponent;
